module.exports = __webpack_public_path__ + "img/addpic.66c98f4a.png";